import { FC, HTMLProps } from 'react';

export const CheckIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M13.5 4.50024L6.5 11.4999L3 8.00025"
        stroke="#202020"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
